import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/evidence';

const namespace = 'EVIDENCE';

export const FETCH_CAD_EVIDENCES_START = `${namespace}/FETCH_CAD_EVIDENCES_START`;
export const FETCH_CAD_EVIDENCES_SUCCESS = `${namespace}/FETCH_CAD_EVIDENCES_SUCCESS`;
export const FETCH_CAD_EVIDENCES_ERROR = `${namespace}/FETCH_CAD_EVIDENCES_ERROR`;

export const fetchCadEvidences = makeApiActionCreatorV3(
  api.fetchEvidences,
  FETCH_CAD_EVIDENCES_START,
  FETCH_CAD_EVIDENCES_SUCCESS,
  FETCH_CAD_EVIDENCES_ERROR,
);

export const FETCH_PLAINTIFF_EVIDENCES_START = `${namespace}/FETCH_PLAINTIFF_EVIDENCES_START`;
export const FETCH_PLAINTIFF_EVIDENCES_SUCCESS = `${namespace}/FETCH_PLAINTIFF_EVIDENCES_SUCCESS`;
export const FETCH_PLAINTIFF_EVIDENCES_ERROR = `${namespace}/FETCH_PLAINTIFF_EVIDENCES_ERROR`;

export const fetchPlaintiffEvidences = makeApiActionCreatorV3(
  api.fetchEvidences,
  FETCH_PLAINTIFF_EVIDENCES_START,
  FETCH_PLAINTIFF_EVIDENCES_SUCCESS,
  FETCH_PLAINTIFF_EVIDENCES_ERROR,
);

export const FETCH_EVIDENCE_START = `${namespace}/FETCH_EVIDENCE_START`;
export const FETCH_EVIDENCE_SUCCESS = `${namespace}/FETCH_EVIDENCE_SUCCESS`;
export const FETCH_EVIDENCE_ERROR = `${namespace}/FETCH_EVIDENCE_ERROR`;

export const fetchEvidence = makeApiActionCreatorV3(
  api.fetchEvidence,
  FETCH_EVIDENCE_START,
  FETCH_EVIDENCE_SUCCESS,
  FETCH_EVIDENCE_ERROR,
);

export const FETCH_EVIDENCE_FILES_START = `${namespace}/FETCH_EVIDENCE_FILES_START`;
export const FETCH_EVIDENCE_FILES_SUCCESS = `${namespace}/FETCH_EVIDENCE_FILES_SUCCESS`;
export const FETCH_EVIDENCE_FILES_ERROR = `${namespace}/FETCH_EVIDENCE_FILES_ERROR`;

export const fetchEvidenceFiles = makeApiActionCreatorV3(
  api.fetchEvidenceFiles,
  FETCH_EVIDENCE_FILES_START,
  FETCH_EVIDENCE_FILES_SUCCESS,
  FETCH_EVIDENCE_FILES_ERROR,
);

export const FETCH_EVIDENCE_FILE_START = `${namespace}/FETCH_EVIDENCE_FILE_START`;
export const FETCH_EVIDENCE_FILE_SUCCESS = `${namespace}/FETCH_EVIDENCE_FILE_SUCCESS`;
export const FETCH_EVIDENCE_FILE_ERROR = `${namespace}/FETCH_EVIDENCE_FILE_ERROR`;

export const fetchEvidenceFile = makeApiActionCreatorV3(
  api.fetchEvidenceFile,
  FETCH_EVIDENCE_FILE_START,
  FETCH_EVIDENCE_FILE_SUCCESS,
  FETCH_EVIDENCE_FILE_ERROR,
);

export const INSERT_EVIDENCE_START = `${namespace}/INSERT_EVIDENCE_START`;
export const INSERT_EVIDENCE_SUCCESS = `${namespace}/INSERT_EVIDENCE_SUCCESS`;
export const INSERT_EVIDENCE_ERROR = `${namespace}/INSERT_EVIDENCE_ERROR`;

export const insertEvidence = makeApiActionCreatorV3(
  api.insertEvidence,
  INSERT_EVIDENCE_START,
  INSERT_EVIDENCE_SUCCESS,
  INSERT_EVIDENCE_ERROR,
);

export const INSERT_EVIDENCE_FILE_START = `${namespace}/INSERT_EVIDENCE_FILE_START`;
export const INSERT_EVIDENCE_FILE_SUCCESS = `${namespace}/INSERT_EVIDENCE_FILE_SUCCESS`;
export const INSERT_EVIDENCE_FILE_ERROR = `${namespace}/INSERT_EVIDENCE_FILE_ERROR`;

export const insertEvidenceFile = makeApiActionCreatorV3(
  api.insertEvidenceFile,
  INSERT_EVIDENCE_FILE_START,
  INSERT_EVIDENCE_FILE_SUCCESS,
  INSERT_EVIDENCE_FILE_ERROR,
);

export const UPDATE_EVIDENCE_START = `${namespace}/UPDATE_EVIDENCE_START`;
export const UPDATE_EVIDENCE_SUCCESS = `${namespace}/UPDATE_EVIDENCE_SUCCESS`;
export const UPDATE_EVIDENCE_ERROR = `${namespace}/UPDATE_EVIDENCE_ERROR`;

export const updateEvidence = makeApiActionCreatorV3(
  api.updateEvidence,
  UPDATE_EVIDENCE_START,
  UPDATE_EVIDENCE_SUCCESS,
  UPDATE_EVIDENCE_ERROR,
);

export const UPDATE_EVDIENCE_TAGS_START = `${namespace}/UPDATE_EVDIENCE_TAGS_START`;
export const UPDATE_EVDIENCE_TAGS_SUCCESS = `${namespace}/UPDATE_EVDIENCE_TAGS_SUCCESS`;
export const UPDATE_EVDIENCE_TAGS_ERROR = `${namespace}/UPDATE_EVDIENCE_TAGS_ERROR`;

export const updateEvidenceTags = makeApiActionCreatorV3(
  api.updateEvidenceTags,
  UPDATE_EVDIENCE_TAGS_START,
  UPDATE_EVDIENCE_TAGS_SUCCESS,
  UPDATE_EVDIENCE_TAGS_ERROR,
);

export const UPDATE_EVIDENCE_FILE_START = `${namespace}/UPDATE_EVIDENCE_FILE_START`;
export const UPDATE_EVIDENCE_FILE_SUCCESS = `${namespace}/UPDATE_EVIDENCE_FILE_SUCCESS`;
export const UPDATE_EVIDENCE_FILE_ERROR = `${namespace}/UPDATE_EVIDENCE_FILE_ERROR`;

export const updateEvidenceFile = makeApiActionCreatorV3(
  api.updateEvidenceFile,
  UPDATE_EVIDENCE_FILE_START,
  UPDATE_EVIDENCE_FILE_SUCCESS,
  UPDATE_EVIDENCE_FILE_ERROR,
);

export const DELETE_EVIDENCE_START = `${namespace}/DELETE_EVIDENCE_START`;
export const DELETE_EVIDENCE_SUCCESS = `${namespace}/DELETE_EVIDENCE_SUCCESS`;
export const DELETE_EVIDENCE_ERROR = `${namespace}/DELETE_EVIDENCE_ERROR`;

export const deleteEvidence = makeApiActionCreatorV3(
  api.deleteEvidence,
  DELETE_EVIDENCE_START,
  DELETE_EVIDENCE_SUCCESS,
  DELETE_EVIDENCE_ERROR,
);

export const DELETE_EVIDENCE_FILE_START = `${namespace}/DELETE_EVIDENCE_FILE_START`;
export const DELETE_EVIDENCE_FILE_SUCCESS = `${namespace}/DELETE_EVIDENCE_FILE_SUCCESS`;
export const DELETE_EVIDENCE_FILE_ERROR = `${namespace}/DELETE_EVIDENCE_FILE_ERROR`;

export const deleteEvidenceFile = makeApiActionCreatorV3(
  api.deleteEvidenceFile,
  DELETE_EVIDENCE_FILE_START,
  DELETE_EVIDENCE_FILE_SUCCESS,
  DELETE_EVIDENCE_FILE_ERROR,
);

export const DOWNLOAD_EVIDENCE_FILE_START = `${namespace}/DOWNLOAD_EVIDENCE_FILE_START`;
export const DOWNLOAD_EVIDENCE_FILE_SUCCESS = `${namespace}/DOWNLOAD_EVIDENCE_FILE_SUCCESS`;
export const DOWNLOAD_EVIDENCE_FILE_ERROR = `${namespace}/DOWNLOAD_EVIDENCE_FILE_ERROR`;

export const downloadEvidenceFile = makeApiActionCreatorV3(
  api.downloadEvidenceFile,
  DOWNLOAD_EVIDENCE_FILE_START,
  DOWNLOAD_EVIDENCE_FILE_SUCCESS,
  DOWNLOAD_EVIDENCE_FILE_ERROR,
);
